// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatMemberTimeoutSetBody = {
  chatId: string;
  userId: string;
  duration: "tenMinutes" | "oneHour" | "oneDay" | "oneWeek";
  reason?: string | null;
};

export type typeChatMemberTimeoutSetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { userId: string; timedOutUntilIso: string };
};

export type typeChatMemberTimeoutSetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatMemberTimeoutSetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatMemberTimeoutSetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatMemberTimeoutSetBody = {
  type: "object",
  properties: {
    chatId: { type: "string", maxLength: 3000, minLength: 1 },
    userId: { type: "string", maxLength: 3000, minLength: 1 },
    duration: {
      type: "string",
      enum: ["tenMinutes", "oneHour", "oneDay", "oneWeek"],
    },
    reason: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["chatId", "userId", "duration"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatMemberTimeoutSet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatMemberTimeoutSetBody);
  }

  return async function postChatMemberTimeoutSet(
    payload: typeChatMemberTimeoutSetBody,
  ): Promise<
    typeChatMemberTimeoutSetOutput200 | typeChatMemberTimeoutSetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatMemberTimeoutSet" failed before calling the network. #d2bca6e68a42`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d2bca6e68a42" },
        },
        data: null,
      } as typeChatMemberTimeoutSetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/member-timeout-set`,
      httpMethod: "POST",
      options,
    })) as
      typeChatMemberTimeoutSetOutput200 | typeChatMemberTimeoutSetOutput400;
  };
}
